import React from "react";
import {
  Box, TextField, InputAdornment, ToggleButtonGroup, ToggleButton
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";

// Solo i valori (già chiavi i18n form.*): l'etichetta si ottiene con t(value).
export const PARTNER_TYPE_OPTIONS = [
  "form.partnerType.pony",
  "form.partnerType.horse",
  "form.partnerType.owner",
  "form.partnerType.other"
];

// Ordine coerente col resto dell'app per i filtri a toggle: Proprietario → Cavallo → Pony.
const PARTNER_TYPE_FILTER = [
  "form.partnerType.owner",
  "form.partnerType.horse",
  "form.partnerType.pony"
];

interface PartnerFiltersProps {
  search: string;
  partnerType: string;
  active: string;
  onSearchChange: (v: string) => void;
  onTypeChange: (v: string) => void;
  onActiveChange: (v: string) => void;
}

export function PartnerFilters({
  search,
  partnerType,
  active,
  onSearchChange,
  onTypeChange,
  onActiveChange
}: PartnerFiltersProps) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        p: 2,
        flexWrap: "wrap",
        alignItems: "center",
        borderBottom: "1px solid rgba(0,0,0,.06)"
      }}
    >
      <TextField
        size="small"
        placeholder={t("partners.searchFilterPlaceholder")}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" sx={{ color: "text.disabled" }} />
            </InputAdornment>
          )
        }}
        sx={{ width: { xs: "100%", sm: 300 } }}
      />

      <ToggleButtonGroup
        size="small"
        color="primary"
        value={partnerType}
        exclusive
        onChange={(_, v) => v !== null && onTypeChange(v)}
      >
        <ToggleButton value="">{t("partners.allTypes")}</ToggleButton>
        {PARTNER_TYPE_FILTER.map((value) => (
          <ToggleButton key={value} value={value}>{t(value)}</ToggleButton>
        ))}
      </ToggleButtonGroup>

      <ToggleButtonGroup
        size="small"
        color="primary"
        value={active}
        exclusive
        onChange={(_, v) => v !== null && onActiveChange(v)}
      >
        <ToggleButton value="">{t("partners.activeToggleAll")}</ToggleButton>
        <ToggleButton value="true">{t("partners.activeToggleActive")}</ToggleButton>
        <ToggleButton value="false">{t("partners.activeToggleInactive")}</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
